export default __webpack_public_path__ + "static/media/course-icon.eb0427b5.svg";